import { Params, PrivateArchivalUnit, Result } from 'types';
import fetch from 'utils/fetch';

/**
 * Function for fetching data for table.
 */
export function fetchTableItems<T>(url: string) {
  return async function (params: Params): Promise<Result<T>> {
    const response = await fetch(`${url}`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(params),
    });
    const json = await response.json();

    return json;
  };
}

export async function getPrivateArchivalUnit(id: string) {
  try {
    const response = await fetch(`/api/archival-unit/private/view/${id}`, {
      method: 'GET',
    });

    const archivalUnit: PrivateArchivalUnit = await response.json();

    return archivalUnit;
  } catch (e) {
    console.log(e);
    return undefined;
  }
}

export async function getArchivalUnitReservation(id: string) {
  try {
    const response = await fetch(`/api/archival-unit/reservation/${id}`, {
      method: 'GET',
    });

    const archivalUnit: PrivateArchivalUnit = await response.json();

    return archivalUnit;
  } catch (e) {
    console.log(e);
    return undefined;
  }
}

export async function requestExtensionForPrivateArchivalUnit(
  id: string,
  expirationDate: string
) {
  try {
    await fetch(
      `/api/archival-unit/private/${id}/request-extension?expirationDate=${expirationDate}`,
      {
        method: 'PUT',
      }
    );

    return {
      ok: true,
      data: {},
    };
  } catch (e) {
    console.log(e);

    return {
      ok: false,
      data: e,
    };
  }
}

export async function requestExtensionForArchivalUnitReservation(
  id: string,
  expirationDate: string
) {
  try {
    await fetch(
      `/api/archival-unit/reservation/${id}/request-extension?expirationDate=${expirationDate}`,
      {
        method: 'PUT',
      }
    );

    return {
      ok: true,
      data: {},
    };
  } catch (e) {
    console.log(e);
    return {
      ok: false,
      data: e,
    };
  }
}
